<template>
  <!-- HST出荷指示書表示 -->
  <div id="HSTShippingDirectionsView">
    <div id="container">
      <div class="labelTitle lable">出荷指示リスト</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>出荷予定日</th>
            <td><input type="date" v-model="searchConditions.shippingDate"/></td>
            <th>機種</th>
            <td style="width:450px;"><select v-model="searchConditions.instrumentKind"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
            <template v-if="isWP300(searchConditions.instrumentKind)">
              <th>いびきセンサー</th>
              <td><select v-model="searchConditions.snoreSensor"><option value="1">無</option><option value="2">有</option></select></td>
            </template>
            <template v-else>
              <th style="background-color:white;border-right:hidden;"></th>
              <td></td>
            </template>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">表示</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <div class="labelTitle lable subTitle" v-if="isShow">{{titleMsg}}</div>
      <div class="button-area" v-if="isShow">
        <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy">クリップボードにコピー</b-button>
      </div>
      <div class="result-area" v-if="isShow">
        <b-table
            id="shippingDirectionsViewTable"
            :data="data"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column v-if="!props.row.holterRequestId" field="holterRequestId" label="ePatch同梱出荷" width="110" centered>無</b-table-column>
              <b-table-column v-if="props.row.holterRequestId" field="holterRequestId" label="ePatch同梱出荷" width="110" centered>有</b-table-column>
              <b-table-column field="snoreSensor" label="いびきセンサー" width="110" centered>{{props.row.snoreSensor | snoreSensorFilter(props.row.modelId) }}</b-table-column>
              <b-table-column field="receiptNumber" label="受付番号" width="70" centered>{{props.row.receiptNumber }}</b-table-column>
              <b-table-column field="serial" label="シリアル" width="150" centered>{{props.row.serial }}</b-table-column>
              <b-table-column v-if="isNightGraf(modelId)" field="electrodeLot" label="電極のロット" width="150" centered>{{props.row.electrodeLot}}</b-table-column>
              <b-table-column v-if="isNightGraf(modelId)" field="cannulaLot" label="カニューラのロット" width="150" centered>{{props.row.cannulaLot}}</b-table-column>
              <b-table-column field="familyName" label="姓" width="150" centered>{{props.row.familyName }}</b-table-column>
              <b-table-column field="firstName" label="名" width="150" centered >{{props.row.firstName }}</b-table-column>
              <b-table-column field="cannulaSize" label="カニューラ" width="80" centered >{{props.row.cannulaSize | getNameFilter(cannulaSizeList)}}</b-table-column>
              <b-table-column field="beltSize" label="ベルト" width="60" centered>{{props.row.beltSize | getNameFilter(beltSizeList)}}</b-table-column>
              <b-table-column field="phoneNumber" label="連絡先" width="100" centered>{{props.row.phoneNumber }}</b-table-column>
              <b-table-column field="zip" label="郵便番号" width="80" centered>{{props.row.zip }}</b-table-column>
              <b-table-column field="receiverAddress" label="住所" >{{props.row.receiverAddress }}</b-table-column>
              <b-table-column field="receiverName" label="配送先宛名">{{props.row.receiverName }}</b-table-column>
              <b-table-column field="deliveryDate" label="納品日" width="80" centered>{{props.row.deliveryDate }}</b-table-column>
              <b-table-column field="desiredDeliveryTimeZone" label="配達希望時間" width="110">{{props.row.desiredDeliveryTimeZone | getNameFilter(desiredDeliveryTimeZoneList)}}</b-table-column>
              <b-table-column field="biko" label="備考" width="250">{{props.row.biko }}</b-table-column>
              <b-table-column label="#1" field="yobi1" width="15">{{props.row.yobi1 }}</b-table-column>
              <b-table-column label="#2" field="yobi2" width="15">{{props.row.yobi2 }}</b-table-column>
              <b-table-column label="#3" field="yobi3" width="15">{{props.row.yobi3 }}</b-table-column>
              <b-table-column label="#4" field="yobi4" width="15">{{props.row.yobi4 }}</b-table-column>
              <b-table-column label="#5" field="yobi5" width="15">{{props.row.yobi5 }}</b-table-column>
              <b-table-column label="#6" field="yobi6" width="15">{{props.row.yobi6 }}</b-table-column>
              <b-table-column label="#7" field="yobi7" width="15">{{props.row.yobi7 }}</b-table-column>
              <b-table-column label="#8" field="yobi8" width="15">{{props.row.yobi8 }}</b-table-column>
              <b-table-column field="tape" label="テープ" width="60" centered>{{props.row.tape }}</b-table-column>
            </template>
        </b-table>
    　</div>
        <div class="button-area" v-if="isShow">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
  </div>
</template>

<script>
import {choicesType, hstModelValue} from "@/components/mock/base/const.js";
export default {
  name: "HSTShippingDirectionsView",
  methods: {
    doSearch: function (){
      if(!this.searchConditions.shippingDate){
        this.showErrorMessage("出荷予定日を選択してください。")
        return;
      }
      this.data = []
      this.isShow = false
      var excuteApi = this.getHstShippingDirectionsListPOST;
      var successCallBack = this.getHstShippingDirectionsListPOSTSuccess;
      var errorCallBack = this.getHstShippingDirectionsListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHstShippingDirectionsListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      return client.apis.internalHst.getHstShippingDirectionsListPOST({
        body:obj
      });
    },
    getHstShippingDirectionsListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        var date = this.searchConditions.shippingDate.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1年$2月$3日');
        var targetModel = this.modelList.find(item => item.value == this.searchConditions.instrumentKind)
        this.titleMsg = date + " " + (targetModel ? targetModel.label1 : "" ) + "出荷指示リスト"
        this.modelId = targetModel.value
        this.isShow = true;
      }
    },
    getHstShippingDirectionsListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function() {
      this.$router.push({
        name: "HSTShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    clipboardCopy: function() {
      var btable = document.getElementById('shippingDirectionsViewTable');
      var tableWrapper = btable.getElementsByClassName('table-wrapper')[0];
      var table = tableWrapper.getElementsByTagName('table')[0];
      var tbody = table.getElementsByTagName('tbody')[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
        console.log(err);
      });
    },
    isWP300: function(instrumentKind) {
      if(instrumentKind == hstModelValue.WP300){
        return true
      }
      return false
    },
    isNightGraf: function(instrumentKind) {
      if(instrumentKind == hstModelValue.NIGHTGRAF){
        return true
      }
      return false
    },
  },
  data() {
    var searchParams = this.$route.params["searchConditions"];
    var modelList = this.getChoiceList(choicesType.hstKind, false);
    var desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    var cannulaSizeList = this.getChoiceList(choicesType.cannulaSize, false);
    var beltSizeList = this.getChoiceList(choicesType.beltSize, false);
    return {
      searchConditions:{
        shippingDate:"",
        instrumentKind:modelList[0].value,
        snoreSensor:"1",
      },
      searchParams,
      data: [],
      isShow: false,
      modelList,
      desiredDeliveryTimeZoneList,
      cannulaSizeList,
      beltSizeList,
      titleMsg:"",
      modelId:"",
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    snoreSensorFilter(value, modelId){
      if (modelId == hstModelValue.WP300) {
        if (value == "1") {
          return "無"
        } else if (value == "2") {
          return "有"
        }
      } else {
        return "-"
      }
    },
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.subTitle,
.result-area {
  margin-top: 20px;
  width:1400px;
}
.result-area {
  max-height: 650px;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/hst/shipping/HSTShippingDirectionsView.vue